/* SoFlo universal carousel: injects prev/next arrows into every .sfc-carousel
   (including ones rendered later by JS) and keeps the arrow states fresh. */
(function () {
  function setup(wrap) {
    if (wrap.dataset.sfcReady) return;
    var track = wrap.querySelector('.sfc-track');
    if (!track) return;
    wrap.dataset.sfcReady = '1';
    var prev = document.createElement('button');
    prev.className = 'sfc-arrow sfc-arrow--prev';
    prev.type = 'button'; prev.setAttribute('aria-label', 'Scroll back'); prev.textContent = '‹';
    var next = document.createElement('button');
    next.className = 'sfc-arrow sfc-arrow--next';
    next.type = 'button'; next.setAttribute('aria-label', 'Scroll forward'); next.textContent = '›';
    wrap.appendChild(prev); wrap.appendChild(next);
    function page(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' }); }
    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    function refresh() {
      var max = track.scrollWidth - track.clientWidth - 2;
      var none = max <= 4; // nothing to scroll
      prev.style.display = next.style.display = none ? 'none' : '';
      wrap.classList.toggle('sfc-has-arrows', !none);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    track.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    if (window.ResizeObserver) new ResizeObserver(refresh).observe(track);
    refresh();
    // content rendered/replaced later (JS-driven pages)
    new MutationObserver(refresh).observe(track, { childList: true, subtree: false });
  }
  function scan() { document.querySelectorAll('.sfc-carousel').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
